import { render, staticRenderFns } from "./DefaultSwitch.vue?vue&type=template&id=ab700f62&"
import script from "./DefaultSwitch.vue?vue&type=script&lang=js&"
export * from "./DefaultSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports